import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function swiperTestimonials() {
    if (typeof Swiper === "undefined") return;

    const swipers = document.querySelectorAll('.testimonial-slider__swiper');
    if (!swipers.length) return;

    swipers.forEach((swiper) => {
        if (swiper.classList.contains('swiper-initialized')) return;

        const parent = swiper.closest('.testimonial-slider');
        if (!parent) return;

        const nextEl = parent.querySelector('.testimonial-slider__next');
        const prevEl = parent.querySelector('.testimonial-slider__prev');
        const pagination = parent.querySelector('.testimonial-slider__pagination');

        const options = {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            centeredSlides: true,
            width: null,
        };

        if (nextEl && prevEl) {
            options.navigation = { nextEl, prevEl };
        }

        if (pagination) {
            options.pagination = {
                el: pagination,
                clickable: true,
            };
        }

        try {
            new Swiper(swiper, options);
        } catch (err) {
            console.warn('Swiper Testimonials init error', err);
        }
    });
}
